// ONB-002 — país y moneda principal del negocio en «Prepara tu negocio». Espejo, SOLO para dibujar los
// selectores, de la lista del servidor (backend/src/domain/onboarding/businessLocale.ts), que es la que
// valida. Hoy Negocio360 funciona de verdad solo en México y en pesos mexicanos (ventas, IVA, cobro con
// lector y pantallas están en MXN): ofrecer otra opción mostraría cifras equivocadas. Agregar un país o
// moneda empieza en el servidor; después se refleja aquí.
import { isMexicanTimezone } from './format';

export interface CountryOption {
  /** ISO 3166-1 alfa-2. */
  code: string;
  label: string;
  /** ISO 4217 que se propone al elegir el país. */
  defaultCurrency: string;
  currencies: readonly string[];
}

export const SUPPORTED_COUNTRIES: readonly CountryOption[] = [
  { code: 'MX', label: 'México', defaultCurrency: 'MXN', currencies: ['MXN'] },
];

const CURRENCY_LABELS: Record<string, string> = {
  MXN: 'Peso mexicano (MXN)',
};

export const currencyLabel = (code: string): string => CURRENCY_LABELS[code] ?? code;

export function countryOption(code: string): CountryOption {
  return SUPPORTED_COUNTRIES.find((country) => country.code === code) ?? SUPPORTED_COUNTRIES[0];
}

/** Las monedas que se pueden elegir para ese país, con su etiqueta. */
export function currencyChoices(countryCode: string): Array<{ value: string; label: string }> {
  return countryOption(countryCode).currencies.map((code) => ({ value: code, label: currencyLabel(code) }));
}

/**
 * El país que se propone: el de la región del idioma del navegador (es-MX → MX) si está soportado; si no,
 * el de la zona horaria del equipo; si no, el primero soportado. Siempre devuelve uno soportado.
 */
export function suggestCountry(language: string | undefined, timezone: string): string {
  const region = (language ?? '').split(/[-_]/)[1]?.toUpperCase();
  if (region && SUPPORTED_COUNTRIES.some((country) => country.code === region)) return region;
  if (isMexicanTimezone(timezone)) return 'MX';
  return SUPPORTED_COUNTRIES[0].code;
}

/** Nota bajo los selectores: qué se puede elegir hoy, dicho claro. */
export const LOCALE_SCOPE_NOTE = 'Por ahora Negocio360 funciona en México y en pesos mexicanos.';
